import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

/**
 * Previous/Next link in pager. Renders an arrow + stacked direction label / page name.
 * Previous: arrow on the left; Next: arrow on the right.
 */
export default function PagerLink({ to, direction, children }) {
  const dir = direction?.toLowerCase() || "";
  const isPrev = dir === "previous";
  const isNext = dir === "next";
  const dirLabel = dir
    ? `${dir.charAt(0).toUpperCase()}${dir.slice(1)}:`
    : "";

  return (
    <Link
      to={to}
      aria-label={dirLabel ? `${dirLabel} ${children}` : undefined}
      className={`flex items-center gap-3 no-underline hover:opacity-75${isNext ? " ml-auto" : ""}`}
      data-direction={direction}
    >
      {isPrev && (
        <span className="text-primary text-3xl leading-none" aria-hidden="true">
          ←
        </span>
      )}
      <span className={`block ${isNext ? "text-right" : "text-left"}`} aria-hidden="true">
        {dirLabel && (
          <span className="block text-sm text-gray-darker">{dirLabel}</span>
        )}
        <span className="block text-primary font-semibold">{children}</span>
      </span>
      {isNext && (
        <span className="text-primary text-3xl leading-none" aria-hidden="true">
          →
        </span>
      )}
    </Link>
  );
}

PagerLink.propTypes = {
  to: PropTypes.string.isRequired,
  direction: PropTypes.oneOf(["previous", "next"]),
  children: PropTypes.node.isRequired,
};

PagerLink.defaultProps = {
  direction: null,
};
